import { createSelector, createFeatureSelector } from '@ngrx/store';
import { HomeFeedState, HomeFeedSection } from './home-feed.model';

export const selectHomeFeedState = createFeatureSelector<HomeFeedState>('homeFeed');

export const selectHomeFeedSections = createSelector(
  selectHomeFeedState,
  (state) => state.sections
);

export const selectHomeFeedCardsBySection = (section: HomeFeedSection) => createSelector(
  selectHomeFeedSections,
  (sections) => sections[section] || []
);
